export default __webpack_public_path__ + "static/media/Roxana.ed0f848e.svg";